import React, { useState } from "react";
import { CategoryV2 } from "src/shared/services/interfacev2";
import { postProduct } from "../../../../../shared/services/services";
import { closeLoading, notifyLoading, notifySuccess } from "../../../../../assets/toastService";
import { errorHandling } from "src/shared/services/errorHandling";
import { EMPTY_FORM, useProductForm } from "./shared/useProductForm";
import ProductFormModal from "./shared/ProductFormModal";

type Props = {
  close: (id: string) => void;
  category: CategoryV2[];
  loading: (state: boolean) => void;
  addmul?: boolean;
  addProduct: boolean;
};

export default function AddProducts({ close, category, loading, addmul, addProduct }: Props) {
  const [multiAdd, setMultiAdd] = useState(false);

  const {
    form, setForm, setField, uom,
    productType, switchProductType,
    barcodeMode, scanMode, setScanMode,
    submit, setSubmit,
    handleImageChange, handleBarcodeDetected,
    discountPrice, finalPrice, discountString, sellingPrice, purchasePrice, wholeSalePrice,
  } = useProductForm({ category, initialState: EMPTY_FORM });

  const canSubmit =
    !!form.productName &&
    !!form.categoryId &&
    !submit &&
    !!form.amountMeasurement &&
    form.uom.length > 0;

  const handleSubmit = async () => {
    setSubmit(true);
    notifyLoading("Adding product...");
    try {
      const payload = new FormData();
      payload.append("productName", form.productName);
      payload.append("amount", form.amount);
      payload.append("arabicName", form.arabicName);
      payload.append("type", form.type);
      payload.append("ownProduct", String(productType === "Inward"));
      payload.append("categoryId", form.categoryId);
      payload.append("productRefId", form.productRefId);
      payload.append("barcodeId", form.barcodeId);
      payload.append("uom", JSON.stringify(form.uom.map((u) => u.id)));
      payload.append("baseUnitType", form.amountMeasurement);
      payload.append("purchasePrice", String(form.purchasePrice));
      payload.append("sellingPrice", String(form.sellingPrice));
      payload.append("discount", discountString ?? "0");
      payload.append("wholeSalePrice", String(form.wholeSalePrice));
      if (form.image instanceof File) payload.append("image", form.image);

      const res = await postProduct(payload);
      notifySuccess("Product added successfully");
      if (!multiAdd) close(res.data._id);
      setForm({ ...EMPTY_FORM });
    } catch (err) {
      errorHandling(err);
    } finally {
      closeLoading();
      setSubmit(false);
    }
  };

  return (
    <ProductFormModal
      isOpen={addProduct}
      title="Add New Product"
      productType={productType}
      switchProductType={switchProductType}
      form={form}
      setField={setField}
      setForm={setForm}
      category={category}
      uom={uom}
      barcodeMode={barcodeMode}
      scanMode={scanMode}
      onToggleScan={() => setScanMode((p) => !p)}
      onBarcodeDetected={handleBarcodeDetected}
      onImageChange={handleImageChange}
      discountPrice={discountPrice}
      finalPrice={finalPrice}
      sellingPrice={sellingPrice}
      purchasePrice={purchasePrice}
      wholeSalePrice={wholeSalePrice}
      canSubmit={canSubmit}
      submit={submit}
      onSubmit={handleSubmit}
      onClose={() => close("")}
      showMultiAdd={!addmul}
      multiAdd={multiAdd}
      onMultiAddChange={setMultiAdd}
    />
  );
}